import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAutoFlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M17.87 8.6A1 1 0 0 0 17 8h-4.58l1.27-4.74a1 1 0 0 0-.17-.87 1 1 0 0 0-.8-.39h-7a1 1 0 0 0-1 .74l-2.68 10a1 1 0 0 0 1 1.26h3.85l-1.81 6.74a1 1 0 0 0 1.71.93l10.9-12a1 1 0 0 0 .18-1.07m-9.79 8.68 1.08-4a1 1 0 0 0-.16-.89 1 1 0 0 0-.81-.39H4.35l2.14-8h4.93l-1.27 4.74a1 1 0 0 0 1 1.26h3.57ZM19 13h-1a3 3 0 0 0-3 3v5a1 1 0 0 0 2 0v-2h3v2a1 1 0 0 0 2 0v-5a3 3 0 0 0-3-3m1 4h-3v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z" />
  </svg>
);
export default SvgAutoFlash;
